module.exports = __webpack_public_path__ + "static/img/cont64 (4).e1fd291.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont64 (4).jpg
// module id = 3LQW
// module chunks = 0